import React from "react";
// import PropTypes from "prop-types";
import {
  Button,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
  Row,
  Col,
  Card,
  CardImg,
  Spinner,
} from "reactstrap";
import { Formik } from "formik";
import UploadButton from "../Components/KeyRecoveryRequest/UploadButton";
import LoadingOverlay from "../Components/LoadingOverlay";
import "react-datepicker/dist/react-datepicker.css";
import bankApi from "@/api/bank";
import swal from "sweetalert2";
import { handleError } from "@/util/errorHandler";
import noPhotoProvided from "@/assets/img/noPhotoProvided.png";
import { MAX_FILE_SIZE_IN_BYTES } from "@/store/constants";
import {
  isPhoneNumber,
  facebookRegExp,
  trimField,
  stripLeadingAt,
} from "@/util/validationHelper";
import InputMask from "react-input-mask";

class UpdateBankInfo extends React.Component {
  state = {
    logoImage: null,
    titleLogoImage: null,
    isLoading: true,
    bin: null,
    phone: null,
    email: null,
    facebook: null,
    facebookMessenger: null,
    whatsapp: null,
    telegram: null,
    address: null,
    website: null,
    logoUuid: null,
    titleLogoUuid: null,
    logo: null,
    titleLogo: null,
    isLogosLoading: false,
    isLogosVisible: false,
  };

  baseState = {
    ...this.state,
  };

  toggleLogosVisibility = () => {
    this.setState(({ isLogosVisible }) => ({
      isLogosVisible: !isLogosVisible,
    }));
  };

  loadBankInfo = async id => {
    try {
      const data = await bankApi.getBankInfo();
      this.setState({ ...data });

      // TODO: Uncomment when integration with payment gateway will be implemented.
      // Or if another solution will be founded
      // this.setState({ isLogosLoading: true });
      // await Promise.all([this.loadBankLogo(), this.loadBanktitleLogo()]);
      // this.setState({ isLogosLoading: false });
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  loadBankLogo = async () => {
    if (this.state.logoUuid) {
      const logo = await bankApi.getBankLogo(this.state.logoUuid);
      this.setState({ logo });
    }
  };

  loadBankTitleLogo = async () => {
    if (this.state.titleLogoUuid) {
      const titleLogo = await bankApi.getBankTitleLogo(
        this.state.titleLogoUuid,
      );
      this.setState({ titleLogo });
    }
  };

  componentDidMount() {
    this.loadBankInfo();
  }

  validateFormik = ({
    bin,
    phone,
    email,
    facebook,
    facebookMessenger,
    whatsapp,
    telegram,
    address,
    website,
  }) => {
    const errors = {};

    if (!bin) {
      errors.bin = "Please enter bank's name";
    }

    if (!phone) {
      errors.phone = "Please enter bank's phone";
    }

    if (phone && phone.length && !isPhoneNumber(phone)) {
      errors.phone = "Incorrect phone number";
    }

    if (phone && phone[5] === "0") {
      errors.phone = "Phone number can’t start with 0";
    }

    if (!email) {
      errors.email = "Please enter bank's email";
    }
    if (
      email &&
      email.length &&
      !/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email,
      )
    ) {
      errors.email = "Incorrect email. Please provide correct bank email";
    }

    const checkFacebook = new RegExp(facebookRegExp).test(facebook);
    if (facebook && facebook.length && !checkFacebook) {
      errors.facebook = "Incorrect facebook address";
    }

    if (!address) {
      errors.address = "Please enter bank's address";
    }

    if (!website) {
      errors.website = "Please enter website";
    }

    if (website && website.length && !/(https?:\/\/[^\s]+)/g.test(website)) {
      errors.website = "Incorrect website. Example: http://example.com/";
    }

    if (facebookMessenger && facebookMessenger.length > 64) {
      errors.facebookMessenger = "Maximum 64 characters allowed";
    }

    if (telegram && telegram.length > 64) {
      errors.telegram = "Maximum 64 characters allowed";
    }

    if (whatsapp && whatsapp.length) {
      if (whatsapp.length > 20) {
        errors.whatsapp = "Maximum 20 characters allowed";
      } else if (!/^\+?[\d\s]+$/.test(whatsapp)) {
        errors.whatsapp = "Only '+', digits and spaces are allowed";
      }
    }

    return errors;
  };

  onSelectBankLogo = file => {
    this.setState({ logoImage: file });
  };

  onSelectBankTitleLogo = file => {
    this.setState({ titleLogoImage: file });
  };

  prepareDataBeforeSubmit = async form => {
    const { logoImage, titleLogoImage } = this.state;
    const nullToEmpty = value => {
      if (value === null || value === undefined) return "";
      return typeof value === "string" ? value.trim() : value;
    };
    const result = Object.keys(form).reduce(
      (acc, key) => ({ ...acc, [key]: nullToEmpty(form[key]) }),
      {},
    );
    result.name = result.bin;
    if (logoImage) {
      result.logo = Array.from(new Uint8Array(await logoImage.arrayBuffer()));
    }

    if (titleLogoImage) {
      result.titleLogo = Array.from(
        new Uint8Array(await titleLogoImage.arrayBuffer()),
      );
    }

    return result;
  };

  onUpdateAccount = async form => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to update Bank contact information?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then(async result => {
      if (result.value) {
        const data = await this.prepareDataBeforeSubmit(form);

        try {
          await bankApi.setBankInfo(data);
          swal(
            "Success",
            "Bank information has been changed successfully",
            "success",
          );
        } catch (error) {
          handleError(error);
        }
      }
    });
  };

  reset = () => {
    this.setState(this.baseState);
  };

  beforeClose = () => {
    this.reset();
    this.props.onModalClose();
  };

  render() {
    const {
      bin,
      phone,
      email,
      facebook,
      facebookMessenger,
      whatsapp,
      telegram,
      address,
      website,
      isLoading,
    } = this.state;

    const form = (
      <Formik
        enableReinitialize={true}
        initialValues={{
          bin,
          phone,
          email,
          facebook,
          facebookMessenger,
          whatsapp,
          telegram,
          address,
          website,
        }}
        validate={this.validateFormik}
        onChange={this.validateFormik}
        onSubmit={this.onUpdateAccount}>
        {({
          values,
          handleSubmit,
          handleChange,
          handleBlur,
          errors,
          setErrors,
        }) => (
          <Card>
            <LoadingOverlay loading={isLoading} />
            <CardHeader>Bank contact information</CardHeader>
            <Form onSubmit={handleSubmit}>
              <CardBody>
                {/* 
                  TODO: Uncomment when integration with payment gateway will be implemented.
                  Or if another solution will be founded.
                */}
                {/* <FormGroup row>
                  <Label sm={3}></Label>
                  <Col sm={9}>
                    <Button
                      color="primary"
                      onClick={this.toggleLogosVisibility}
                      data-cy="show-photos">
                      {this.state.isLogosVisible ? "Hide" : "Show"}
                    </Button>
                    <Collapse isOpen={this.state.isLogosVisible}>
                      <Card style={{ marginTop: 5 }}>
                        <CardBody style={{ width: "100%" }}>
                          {this.displayLogos()}
                        </CardBody>
                      </Card>
                    </Collapse>
                  </Col>
                </FormGroup> */}
                <FormGroup row>
                  <Label sm={3}>Name</Label>
                  <Col sm={9}>
                    <Input
                      type="text"
                      name="bin"
                      placeholder="Enter bank's name"
                      invalid={Boolean(errors.bin)}
                      value={values.bin}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled
                    />
                    {errors.bin && (
                      <FormFeedback className="text-alert">
                        {errors.bin}
                      </FormFeedback>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={3}>Hotline</Label>
                  <Col sm={9}>
                    <InputMask
                      name="phone"
                      mask="+855 99 999 9999"
                      maskChar=""
                      value={values.phone}
                      onChange={handleChange}>
                      {inputProps => (
                        <Input
                          {...inputProps}
                          placeholder="Enter bank's phone"
                          type="text"
                          autocomplete="off"
                          disableUnderline
                          invalid={Boolean(errors.phone)}
                        />
                      )}
                    </InputMask>
                    {errors.phone && (
                      <FormFeedback className="text-alert">
                        {errors.phone}
                      </FormFeedback>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={3}>Email</Label>
                  <Col sm={9}>
                    <Input
                      type="text"
                      name="email"
                      placeholder="Enter bank's email"
                      invalid={Boolean(errors.email)}
                      value={values.email}
                      onChange={e => handleChange(trimField(e))}
                      onBlur={handleBlur}
                    />
                    {errors.email && (
                      <FormFeedback className="text-alert">
                        {errors.email}
                      </FormFeedback>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={3}>Address</Label>
                  <Col sm={9}>
                    <Input
                      type="text"
                      name="address"
                      placeholder="Enter bank's address"
                      invalid={Boolean(errors.address)}
                      value={values.address}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.address && (
                      <FormFeedback className="text-alert">
                        {errors.address}
                      </FormFeedback>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={3}>Website</Label>
                  <Col sm={9}>
                    <Input
                      type="text"
                      name="website"
                      placeholder="Enter bank's website"
                      invalid={Boolean(errors.website)}
                      value={values.website}
                      onChange={e => handleChange(trimField(e))}
                      onBlur={handleBlur}
                    />
                    {errors.website && (
                      <FormFeedback className="text-alert">
                        {errors.website}
                      </FormFeedback>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={3}>Facebook link</Label>
                  <Col sm={9}>
                    <Input
                      type="text"
                      name="facebook"
                      placeholder="Enter bank's facebook link"
                      invalid={Boolean(errors.facebook)}
                      value={values.facebook}
                      onChange={e => handleChange(trimField(e))}
                      onBlur={handleBlur}
                    />
                    {errors.facebook && (
                      <FormFeedback className="text-alert">
                        {errors.facebook}
                      </FormFeedback>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={3}>Facebook Messenger</Label>
                  <Col sm={9}>
                    <Input
                      type="text"
                      name="facebookMessenger"
                      placeholder="Enter bank's Facebook Messenger's username"
                      maxLength={64}
                      invalid={Boolean(errors.facebookMessenger)}
                      value={values.facebookMessenger}
                      onChange={e => handleChange(stripLeadingAt(trimField(e)))}
                      onBlur={handleBlur}
                    />
                    {errors.facebookMessenger && (
                      <FormFeedback className="text-alert">
                        {errors.facebookMessenger}
                      </FormFeedback>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={3}>WhatsApp</Label>
                  <Col sm={9}>
                    <Input
                      type="text"
                      name="whatsapp"
                      placeholder="Enter bank's WhatsApp's phone number"
                      maxLength={20}
                      invalid={Boolean(errors.whatsapp)}
                      value={values.whatsapp}
                      onChange={e => handleChange(trimField(e))}
                      onBlur={handleBlur}
                    />
                    {errors.whatsapp && (
                      <FormFeedback className="text-alert">
                        {errors.whatsapp}
                      </FormFeedback>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={3}>Telegram</Label>
                  <Col sm={9}>
                    <Input
                      type="text"
                      name="telegram"
                      placeholder="Enter bank's Telegram's username"
                      maxLength={64}
                      invalid={Boolean(errors.telegram)}
                      value={values.telegram}
                      onChange={e => handleChange(stripLeadingAt(trimField(e)))}
                      onBlur={handleBlur}
                    />
                    {errors.telegram && (
                      <FormFeedback className="text-alert">
                        {errors.telegram}
                      </FormFeedback>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={3}>Logo</Label>
                  <Col sm={9}>
                    <UploadButton
                      defaultText="Attach image"
                      onSelectFile={bankLogoFile => {
                        setErrors({ ...errors, bankLogoFile: undefined });
                        this.onSelectBankLogo(bankLogoFile);
                      }}
                      accept="image/png"
                      maxFileSize={MAX_FILE_SIZE_IN_BYTES}
                    />
                    {errors.bankLogoFile && (
                      <FormFeedback className="text-alert">
                        {errors.bankLogoFile}
                      </FormFeedback>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={3}>Title logo</Label>
                  <Col sm={9}>
                    <UploadButton
                      defaultText="Attach image"
                      onSelectFile={titleLogoImage => {
                        setErrors({ ...errors, titleLogoImage: undefined });
                        this.onSelectBankTitleLogo(titleLogoImage);
                      }}
                      accept="image/png"
                      maxFileSize={MAX_FILE_SIZE_IN_BYTES}
                    />
                    {errors.titleLogoImage && (
                      <FormFeedback className="text-alert">
                        {errors.titleLogoImage}
                      </FormFeedback>
                    )}
                  </Col>
                </FormGroup>
              </CardBody>
              <CardFooter>
                <div className="buttons">
                  <Button color="primary" type="submit">
                    <span>Update</span>
                  </Button>
                </div>
              </CardFooter>
            </Form>
          </Card>
        )}
      </Formik>
    );

    return form;
  }

  displayLogos = () => {
    if (this.state.isLogosLoading) {
      return <Spinner color="danger" />;
    }

    return (
      <Row>
        <Col sm="6">
          <Card>
            <CardImg
              src={this.state.logo || noPhotoProvided}
              name="Bank logo"
              data-cy="bank-logo"
            />
          </Card>
        </Col>
        <Col sm="6">
          <Card>
            <CardImg
              src={this.state.titleLogo || noPhotoProvided}
              name="Bank square logo"
              data-cy="bank-square-logo"
            />
          </Card>
        </Col>
      </Row>
    );
  };
}

export default UpdateBankInfo;
